import { Button, Drawer, Grid } from "@mui/material";
import styled from "styled-components";
import { deviceSpec } from "breakpoints";

export const SearchAndStatusBarGrid = styled(Grid)`
  margin-top: 1em;
`;

export const DataTableGrid = styled(Grid)`
  margin-top: 10px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-top: 1px solid rgba(255, 255, 255, 0.5);
`

export const RefreshingAnimation = styled.div`
  -webkit-animation: spin1 2s infinite linear;
  -moz-animation: spin1 2s infinite linear;
  -o-animation: spin1 2s infinite linear;
  -ms-animation: spin1 2s infinite linear;
  animation: spin1 2s infinite linear;
  display: block;

  svg {
    width: 24px;
    height: 24px;
  }

  @-webkit-keyframes spin1 {
    0% { -webkit-transform: rotate(0deg);}
    100% { -webkit-transform: rotate(360deg);}
  }
  @-moz-keyframes spin1 {
    0% { -moz-transform: rotate(0deg);}
    100% { -moz-transform: rotate(360deg);}
  }
  @-o-keyframes spin1 {
    0% { -o-transform: rotate(0deg);}
    100% { -o-transform: rotate(360deg);}
  }
  @-ms-keyframes spin1 {
    0% { -ms-transform: rotate(0deg);}
    100% { -ms-transform: rotate(360deg);}
  }
  @keyframes spin1 {
    0% { transform: rotate(0deg);}
    100% { transform: rotate(360deg);}
  }
`

export const AgenticConversationSidebarContainer = styled('div')`
  svg {
    width: 24px;
    height: 24px;
  }
`

export const FilterButton = styled(Button)`
  background-color: ${({ theme }) => theme.name === 'light-theme' ? theme.colors.lightButton : theme.colors.lightButton} !important;
  color: ${({ theme }) => theme.colors.white} !important;
  border-radius: 8px !important;
  text-transform: none;
  padding: 6px 16px;
  font-weight: 500;
  font-size: 14px;
  min-width: max-content !important;
  
  svg {
    min-width: 20px;
    min-height: 20px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.name === 'light-theme' ? theme.colors.sidebarLightHover : theme.colors.sidebarLightHover} !important;
    box-shadow: 0 4px 12px rgba(161, 0, 255, 0.3);
  }
`;

export const ExportButton = styled(Button)`
  background-color: ${({ theme }) => theme.name === 'light-theme' ? theme.colors.lightButton : theme.colors.lightButton} !important;
  color: ${({ theme }) => theme.colors.white} !important;
  border-radius: 8px !important;
  text-transform: none;
  padding: 6px 16px;
  font-weight: 500;
  font-size: 14px;
  min-width: max-content !important;
  height: 36px;

  svg {
    min-width: 20px;
    min-height: 20px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.name === 'light-theme' ? theme.colors.sidebarLightHover : theme.colors.sidebarLightHover} !important;
    box-shadow: 0 4px 12px rgba(161, 0, 255, 0.3);
  }
`;


export const FiltersAppliedBadge = styled("span")`
  & > p {
    width: max-content;
  }
`

export const BadgeCount = styled("p")({
  alignSelf: "center",
  fontWeight: "400",
  fontSize: "12px",
});

export const CardListViewBtn = styled(Button)<{ selected: boolean }>(
  ({ selected }: { selected: boolean }) => ({
    "&.MuiButton-root": {
      background: selected ? "#AF24FF" : "transparent",
      border: "1px solid white",
      padding: "0px 6px",
      minWidth: "0px",
      height: "30px",
    },
  })
);

export const CalendarBtn = styled(Button)({
  "&.MuiButton-root": {
    border: "0.808989px solid #76766b",
    height: "42px",
    alignSelf: "center",
    gap: 12,
    borderBottomRightRadius: "unset",
    borderTopRightRadius: "unset",
  },
});


// Alerts Toolbar
export const AlertsToolBarGrid = styled(Grid)`
  margin-top: 0.5rem;
  display: flex;
  justify-content: space-between;

  .all-filters {
    margin-right: 0;
  }

  @media ${deviceSpec.isTablet} {
    .all-filters {
      display: none;
    }
  }

  @media ${deviceSpec.isMobile} {
    margin-top: 0px;
    margin-bottom: 15px;

    flex-direction: column !important;

    .MuiGrid-item {
      flex-direction: column !important;

      .MuiGrid-item {
        margin: 0;
      }

      button {
        align-self: start;
        align-items: center;
        margin: 0 8px;
      }

      button:nth-child(2) {
        margin: 8px;
      }

      button:nth-child(1) {
        margin-top: 8px;
      }
    }
  }
`;

export const FilterTitle = styled("p")`
  width: max-content;
`;

export const ExportBtn = styled(Button)`
  height: 30px;
  &.MuiButton-root: {
    border: 1px solid white;
  };
  gap: 11;
  height: 30px;
  
  align-self: center;
  &.MuiButton-root {
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    gap: 10px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
  color: ${({ theme }) => theme.colors.buttonText} !important;
  border-radius: 5px !important;
  background-color: ${({ theme }) => theme.colors.buttonBackground} !important;
  border-color: ${({ theme }) => theme.colors.buttonBorder} !important;
  
  :hover {
    border-color: ${({ theme }) => theme.colors.buttonBorderHighlight} !important;
  }
`;


export const AlertsToolbarLeftGrid = styled(Grid)({

  
});

export const AlertsToolbarRightGrid = styled(Grid)({
  display: "flex",
  justifyContent: "flex-end",
  
});


export const TabletMobileToolBar = styled('div')`
  .component-hidden {
    transform: translateY(-20px) scale(0.95);
    display: none;
  }

  .component-visible {
    padding: 1em;
    transform: translateY(0) scale(1);
    transition: opacity 0.4s ease-out, transform 0.4s ease-out;
    width: 100%;

    @media ${deviceSpec.isDesktop} {
        display: none;
    }

    @media ${deviceSpec.isLaptop} {
        display: none;
    }

    @media ${deviceSpec.isTablet} {
      display: block;
    }
  }
`

export const AlertsBox = styled('div')`
    & > div {
    box-shadow: none !important;
  }
`

export const DesktopToolBar = styled('div')`
  @media ${deviceSpec.isTablet} {
    display: none;
  }

  @media ${deviceSpec.isMobile} {
    display: none;
  }
`

export const SidebarIcon = styled.div`
  svg {
    width: 24px;
    height: 24px;
  }
  display: flex;
  align-items: center;
  justify-content: center;
`